





















import {
    defineComponent,
    onMounted,
    onUnmounted,
    ref,
    watch,
} from '@vue/composition-api';
import { RouteName } from '@app/router/constants/RouteName';
import AccountMenuHeader from './AccountMenuHeader.vue';
import AccountMenuBody from './AccountMenuBody.vue';
import {
    getKey,
    Keys,
    useVueRouter,
} from '@superbet-group/web.lib.vue-utilities';

export default defineComponent({
    name: 'NewAccountMenu',
    emits: ['hideDropdown'],
    props: {
        isAccountDropdownVisible: {
            type: Boolean,
            required: true,
        },
    },
    setup(props, { emit }) {
        const { route } = useVueRouter();

        const backdrop = ref<null | HTMLElement>(null);

        const onKeyup = (event: KeyboardEvent) => {
            const key = getKey(event);

            if (key === Keys.ESC) {
                emit('hideDropdown');
            }
        };

        onMounted(() => {
            backdrop.value?.focus();
            document.addEventListener('keyup', onKeyup);
        });

        onUnmounted(() => document.removeEventListener('keyup', onKeyup));

        watch(route, () => {
            if (props.isAccountDropdownVisible) {
                emit('hideDropdown');
            }
        });

        return {
            RouteName,
        };
    },
    components: {
        AccountMenuHeader,
        AccountMenuBody,
    },
});
